var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"endorsement-title"},[_vm._v(_vm._s(_vm.$t("report.endorsement_report_info_month")))]),_c('div',{staticClass:"graphic-container"},[_c('apexchart',{attrs:{"type":"bar","height":"400","options":_vm.chartOptions,"series":_vm.series,"width":"100%"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }